module.exports = __webpack_public_path__ + "static/soybeans-d05945c01e5d1c6060510905c3938700.jpg";